<template>
  <div v-if="listData">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="功能权限" name="first">
        <fun_ction @clickMore="clickMore" :listData="listData"></fun_ction>
      </el-tab-pane>
      <el-tab-pane label="数据权限" name="second">
        <scope @clickMore="clickMore" :listData="listData" ></scope>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import fun_ction from './permission/function';
  import scope from './permission/scope';
  export default {
      components: {
        fun_ction,
        scope
      },
    data () {
      return {
        userInfo: this.$store.state.userInfo,
        activeName: 'first',
        listData:{},
      }
    },
    mounted(){
      let vm = this
      http.get(InterfacePrefix['platform']+'/user/authority/'+vm.$store.state.userInfo.id).then(xhr=>{
        vm.listData = xhr.data.data
      })
    },
    methods:{
      handleClick(tab, event) {
        let vm = this
      },
      clickMore(){
        let vm = this
      },
    },
  }
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/setting/basic_information/myPermission.vue